import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class ListEventTypesQuery implements IMessage {

    public constructor(init?: Partial<ListEventTypesQuery>) {
        Object.assign(this, init);
    }

    getMethod = () => "GET";

    getUrl = () => `/admin/event-types`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}